export function conditionalInclude<T>(condition: boolean, ...item: T[]): T[] {
  return condition ? item : []
}
